<template>
  <div>
    <el-dialog title="初始化"
               :visible.sync="dialogVisible"
               v-dialogDrag
               :close-on-click-modal="false"
               :append-to-body="true"
               width="400px"
               :before-close="handleClose">
      <el-form :model="form"
               :rules="rules"
               ref="formRef"
               label-width="60px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="届"
                          prop="graduated">
              <el-select v-model="form.graduated"
                         style="width:100%"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in $parent.graduatedList"
                           :key="item.graduated_id"
                           :label="item.year_desc"
                           :value="item.graduated_id" />
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="save">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      form: {},
      subjectList: [],
      textbookList: [],
      rules: {
        grade_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        graduated: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    }
  },
  computed: {},
  methods: {
    getSubject () {
      if (this.form.grade_id == '') return
      this.$http({
        url: '/api/v1/school/get_subject',
        method: 'get',
        params: {
          grade_id: this.form.grade_id
        }
      }).then(res => {
        this.subjectList = res.data.list
      })
    },
    handleClose () {
      this.$refs.formRef.resetFields()
      this.dialogVisible = false
    },
    save () {
      let form = JSON.parse(JSON.stringify(this.form))
      this.$refs.formRef.validate(val => {
        if (!val) return
        this.$http({
          url: '/api/v1/chapter/initList',
          method: 'post',
          data: form
        }).then(res => {
          this.$notify({
            title: '提示',
            message: '操作成功!',
            type: 'success'
          });
          this.$parent.refresh()
          this.handleClose()
        })
      })
    },
    getTextbookList () {
      this.$http({
        url: '/api/v1/public/textbook',
        method: 'get',
      }).then(res => {
        this.textbookList = res.data
      })
    }

  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 20px;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4px;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.toopic {
  font-size: 12px;
  line-height: 14px;
  span {
    margin-left: -12px;
    display: inline-block;
    width: 100%;
    width: 305px;
    color: #ff8383;
    transform: scale(0.9);
  }
}

::v-deep .el-dialog {
  border-radius: 15px;
}
.el-tabs {
  margin-left: 20px;
}
::v-deep .el-tabs__nav-wrap::after {
  background: none;
}
.warp {
  display: flex;
  margin-top: 20px;
  div {
    &:nth-child(1) {
      flex: 1;
      margin-left: 8px;
    }
    &:nth-child(2) {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>